module.exports = __webpack_public_path__ + "img/right.6743d56a.png";